import { create } from "zustand";

type Views = "main" | "analytics" | "logs" | "pdars" | "jessica";

type PdarViewState = {
  view: Views;
  setView: (view: Views) => void;
};

export const usePdarView = create<PdarViewState>((set) => ({
  view: "main",
  setView: (view) => set(() => ({ view })),
}));
